import { memo } from 'react'

import useSelectedItems from '../../states/useSelectedItems'
import { CompareItemsTableAttributeCell as TCompareItemsTableAttributeCell } from '../../types'

import style from './AttributeCell.module.scss'

export default memo(
  CompareItemsTableAttributeCell,
  (prevProps, nextProps) =>
    prevProps.width === nextProps.width &&
    prevProps.className === nextProps.className &&
    prevProps.cell === nextProps.cell
)
export function CompareItemsTableAttributeCell({
  className,
  width,
  cell
}: {
  className: string
  width: number
  cell: TCompareItemsTableAttributeCell
}) {
  const selectedItems = useSelectedItems()

  const attribute = cell.attribute

  return (
    <div
      className={`${className || ''} ${style.CompareItemsTableAttributeCell} ${
        !cell.sortable ? style['CompareItemsTableAttributeCell--not-sortable'] : ''
      } ${attribute.info ? style['CompareItemsTableAttributeCell--info'] : ''} ${
        null != cell.sorted ? style['CompareItemsTableAttributeCell--sorted'] : ''
      }`}
      style={{ flex: `0 0 ${width}px`, width: `${width}px` }}
      onClick={
        cell.sortable
          ? () => {
              selectedItems.setSortByAttribute(cell.attributeIndex, -1 === cell.sorted)
            }
          : null
      }
    >
      {cell.position ? <div className={style.CompareItemsTableAttributeCell__position}>{cell.position}.</div> : null}
      <div className={style.CompareItemsTableAttributeCell__text}>{cell?.text || ''}</div>
      {null != cell.sorted ? (
        <div className={style.CompareItemsTableAttributeCell__sortIcon}>{1 === cell.sorted ? '▴' : '▾'}</div>
      ) : null}
    </div>
  )
}
